import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { WebElement } from '../../../state-management/model/interfaces/state.model';
import { EditableTextComponent } from '../../base/text/editable-text/editable-text.component';

@Component({
    selector: 'app-s-header',
    standalone: true,
    imports: [
        EditableTextComponent
    ],
    templateUrl: './s-header.component.html',
    styleUrl: './s-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SHeaderComponent {
  elemIds = input<string[]>([]);

  private stateService = inject(WebsiteStateService);
  private elements: Signal<Record<string, WebElement>> = this.stateService.elements;

  public titleId = computed(() => {
    const titleElement = this.elemIds()
      .map(id => this.elements()[id])
      .find(element => element && element.label === 'title');
    return titleElement ? titleElement.id : '';
  });

  public subtitleId = computed(() => {
    const subtitleElement = this.elemIds()
      .map(id => this.elements()[id])
      .find(element => element && element.label === 'subtitle');
    return subtitleElement ? subtitleElement.id : '';
  });
}
